import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Switch, Redirect } from 'react-router-dom';
import AuthFlow from '../AuthFlow/';
import Dashboard from '../Dashboard/';
import ProtectedRoute from '../ProtectedRoute';
import { publicHash, AUTH_STATES } from '../../utils/constants'; // using public hash for hosting at /some-address
import './App.scss';
import { setClientLastURL, getClientLastURL } from '../../utils/helpers';


class App extends Component {
  static propTypes = {
    resetUserStore: PropTypes.func.isRequired,
    resetRegistrationStore: PropTypes.func.isRequired,
    resetCampaignStore: PropTypes.func.isRequired,
    isAuthorized: PropTypes.string.isRequired,
  }


  componentDidUpdate(prevProps) {
    const {
      resetRegistrationStore, resetUserStore, resetCampaignStore, isAuthorized,
    } = this.props;
    if (isAuthorized !== prevProps.isAuthorized && isAuthorized === AUTH_STATES.DEAUTH) {
      resetCampaignStore();
      resetRegistrationStore();
      resetUserStore();
    }
    const locSubscriber = window.location.pathname.indexOf('auth');
    if (locSubscriber < 0) {
      if (window.location.pathname !== '/dev/app' && window.location.pathname !== '/app') {
        setClientLastURL(window.location.pathname);
      }
    } else if (getClientLastURL() === null) {
      setClientLastURL('/null');
    }
  }
  render() {
    return (
      <div>
        <Switch>
          <ProtectedRoute path={`${publicHash}/auth`} component={AuthFlow} />
          <ProtectedRoute path={`${publicHash}/app`} component={Dashboard} />
          <Redirect exact from={`${publicHash}/`} to={`${publicHash}/app`} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.js